/* eslint-disable eqeqeq */
import * as React from "react";
import { CaretSortIcon, CheckIcon } from "@radix-ui/react-icons";
import InfiniteScroll from "react-infinite-scroller";

import { cn } from "../lib/utils";
import { Button } from "./ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { XIcon } from "lucide-react";

const SearchSelect = ({
  frameworks,
  optionType,
  handleSelect,
  handleBlur,
  className,
  disabled = false,
  initialValue,
  clearable = false,
  onClear = false,
  itemsPerPage = 10,
  handleSearch
}) => {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(initialValue);

  const handleClear = (e) => {
    setValue("");
    onClear && onClear("");
  };

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const showItems = (frameworks) => {
    var items = [];
    for (var i = 0; i < records; i++) {
      if (frameworks[i]?.label) {
        items.push(
          <CommandItem
            key={frameworks[i]?.value}
            value={frameworks[i]?.label}
            onSelect={(currentValue) => {
              // setValue(currentValue === value ? "" : currentValue);
              setOpen(false);
              handleSelect(
                frameworks.find(
                  (framework) => framework?.label === currentValue
                )?.value
              );
              setValue(
                frameworks.find(
                  (framework) => framework?.label === currentValue
                )?.value
              );
            }}
            disabled={disabled}
          >
            {frameworks[i]?.label}
            <CheckIcon
              className={cn(
                "ml-auto h-4 w-4",
                value === frameworks[i]?.value ? "opacity-100" : "opacity-0"
              )}
            />
          </CommandItem>
        );
      }
    }
    return items;
  };
  const [hasMore, setHasMore] = React.useState(true);
  const [records, setrecords] = React.useState(itemsPerPage);

  const loadMore = () => {
    if (records >= frameworks.length) {
      setHasMore(false);
    } else {
      setHasMore(true);
      setTimeout(() => {
        setrecords(records + itemsPerPage);
      }, 2000);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={`w-full justify-between h-9 px-3 ${
            value
              ? "font-normal text-left overflow-hidden"
              : "text-muted-foreground font-normal"
          } ${className ? className : ""}`}
          onBlur={handleBlur}
          disabled={disabled}
          title={
            value
              ? frameworks.find((framework) => framework?.value == value)?.label
              : ""
          }
        >
          <span className="truncate flex-1 min-w-0 text-left">
            {value
              ? frameworks.find((framework) => framework?.value == value)?.label
              : `Select ${optionType}...`}
          </span>
          {clearable && value ? (
            <XIcon
              className="ml-2 h-4 w-4 shrink-0 cursor-pointer opacity-50"
              onClick={(event) => {
                event.stopPropagation();
                handleClear();
              }}
            />
          ) : (
            <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-full p-0"
        onPointerDownOutside={(e) => e.stopPropagation()}
        onFocusOutside={(e) => e.preventDefault()}
        onWheelCapture={(e) => e.stopPropagation()}
      >
        <Command>
          {handleSearch ? (
            <CommandInput
              placeholder={`Search ${optionType}...`}
              className="h-9"
              onValueChange={handleSearch}
            />
          ) : (
            <CommandInput
              placeholder={`Search ${optionType}...`}
              className="h-9"
            />
          )}
          <CommandList>
            <CommandEmpty>No {optionType} found.</CommandEmpty>
            <CommandGroup>
              <InfiniteScroll
                pageStart={0}
                loadMore={loadMore}
                hasMore={hasMore}
                loader={<h4 className="loader">Loading...</h4>}
                useWindow={false}
              >
                {showItems(frameworks)}
              </InfiniteScroll>
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SearchSelect;
